import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { first } from 'rxjs/operators';
import { ReportsService } from 'src/app/shared';

@Component({
  selector: 'app-candidate-exam-progress',
  templateUrl: './candidate-exam-progress.component.html',
  styleUrls: ['./candidate-exam-progress.component.scss']
})
export class CandidateExamProgressComponent implements OnChanges {

  @Input() center: any;
  @Input() batch: any;
  @Input() progressType: string = 'appearing';

  rows: any[] = [];
  loading = false;
  error = '';

  private titleMap: { [key: string]: string } = {
    appearing: 'Appearing Candidates',
    reappearing: 'Reappearing Candidates',
    submitted: 'Submitted Candidates'
  };

  constructor(private reportsService: ReportsService) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.center && this.center) || (changes.batch && this.batch) || changes.progressType) {
      this.fetch();
    }
  }

  get centerCode(): any {
    return this.center;
  }

  get batchCode(): any {
    return this.batch;
  }

  get title(): string {
    const key = String(this.progressType || '').toLowerCase();
    return this.titleMap[key] || 'Exam Progress Candidates';
  }

  get showReason(): boolean {
    return String(this.progressType || '').toLowerCase() === 'reappearing';
  }

  get showStartedAt(): boolean {
    const key = String(this.progressType || '').toLowerCase();
    return key === 'appearing' || key === 'submitted';
  }

  get showStoppedAt(): boolean {
    return String(this.progressType || '').toLowerCase() === 'submitted';
  }

  fetch(): void {
    if (!this.centerCode || !this.batchCode || !this.progressType) {
      return;
    }

    this.loading = true;
    this.error = '';

    this.reportsService.getExamProgress(this.centerCode, this.batchCode, this.progressType)
      .pipe(first())
      .subscribe({
        next: (res: any) => {
          if (res && res.status === 'error') {
            this.error = res.message || 'Unable to load exam progress right now.';
            this.rows = [];
          } else {
            this.rows = Array.isArray(res) ? res : [];
          }
          this.loading = false;
        },
        error: () => {
          this.error = 'Unable to load exam progress right now.';
          this.loading = false;
        }
      });
  }

  refresh(): void {
    this.fetch();
  }
}
